import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getSavedFilterSets, updateSavedFilterSets } from './AccountActivityAPI'
import { DeserializedSavedFilter } from './AccountActivityAPI/types'

const useNotificationsFilters = () => {
  const queryClient = useQueryClient()

  const { data } = useQuery({
    queryKey: ['getSavedFilterSets'],
    queryFn: () => getSavedFilterSets()
  })

  const mutation = useMutation({
    mutationFn: (payload: DeserializedSavedFilter[]) => updateSavedFilterSets(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getSavedFilterSets']
      })
    }
  })

  return { filterSettings: data, handleUpdateFilterSettings: mutation.mutate }
}

export default useNotificationsFilters
